enum FeeDisplayLayout {
	NoFee = 0,
	DetailFee = 1,
	SummaryFee = 2,
	BonificationLayout = 3
}

export default FeeDisplayLayout;
